<template>
    <div>
        <v-col cols="12">
            <horiba-data-table :list-route="listRoute" :columns="columns"></horiba-data-table>
        </v-col>
    </div>
</template>

<script>
export default {
    props: {
        listRoute: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            columns: [
                {
                    text: t('quality-control::grid.label.id'),
                    value: '*,id',
                    sortable: false,
                },
                {
                    text: t('quality-control::grid.label.list_name'),
                    value: 'list_name',
                    width: 400,
                    sortable: true,
                },
                {
                    text: t('quality-control::grid.label.publishing_date'),
                    value: 'created_at',
                    width: 300,
                    sortable: true,
                },
                {
                    text: t('quality-control::grid.label.expiration_date'),
                    value: 'expires_on',
                    width: 300,
                    sortable: true,
                },
                {
                    text: t('quality-control::grid.label.status'),
                    value: 'is_active',
                    width: 200,
                    sortable: true,
                },
                {
                    text: t('quality-control::grid.label.target_values'),
                    value: 'file_id',
                    width: 200,
                    sortable: false,
                    align: 'end',
                },
            ],
        };
    },
};
</script>
